import * as React from 'react'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const AuditLogPage = React.lazy(() => import('modules/audit_log/pages/settings/AuditLogPage'))

const settingsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.settings.auditLog.path,
      element: <AuditLogPage />,
      handle: {
        meta: () => ({
          illustration: 'group',
          title: i18n.t('settings.audit_log.title'),
          description: i18n.t('settings.audit_log.description'),
        }),
      },
    },
  ]
}

export default settingsRoutes
